import {
  ADD_SEQUENCES, ADD_SEQUENCES_FAIL, SET_BUILDER_CITY,
  ADD_BUILDER_ITEM, REMOVE_BUILDER_ITEM, ADD_SEQUENCES_LOADING,
  ADD_RESERVATION_ITEM, REMOVE_RESERVATION_ITEM,
  CLEAR_BUILDER_LIST
} from './types';
import axios from 'axios';
import { history } from '../components/app';
import { SLACK_WEBHOOKS, CYOA_NETWORK_IDS } from '../config';
import { SlackWebhook } from './utils';

/**
 * Add sequences via Busabout API
 *
 * @param {string} currencyCode - ISO currency code
 * @param {array} reservations - Reservations
 * @param {array} builderlist - List of builder items
 * @param {String} tourID - The ID of the tour (europe / USA)
 */
export function AddSequences(currencyCode, reservations, builderlist, tourID = CYOA_NETWORK_IDS["europe"].id){

  let trips = [];

  //Populate city_id for products
  for(let i = 0; i < builderlist.length; i++){
    if(builderlist[i].type === 'product'){
        trips.push({
          "tour_id": builderlist[i].tour_id,
          //"city_id": (i === builderlist.length -1) ? builderlist[i-1].reservations.end_city_id : builderlist[i+1].reservations.end_city_id,
          "city_id": builderlist[i-1].reservations ? builderlist[i-1].reservations.end_city_id : 1,
          "departure_date": null,
          "promo_code": "",
          "passengers": [],
          "add_ons": []
        });
    }
  }

  trips.push({
    "tour_id": tourID,
    "city_id": 3037, //Different city_id for usa???
    "departure_date": null,
    "passengers": [{
      "index": 0,
      "price": 0,
      "reservations": reservations
    }]
  });


  const payload = {
  	"booking_information": {
  		"iso_currency_code": currencyCode
  	},
  	"trips": trips,
    "passengers": [{
      "age_category": "Adult"
    }]
  }

  const config = {
     headers:{
       'Content-Type': 'text/plain'
     },
     withCredentials: true
  };

 
  const SEQUENCE_URL = `${process.env.REACT_APP_NETWORK_API}${tourID}/sequences?api_token=${process.env.REACT_APP_API_TOKEN}`;

  return async dispatch => {

    dispatch({type:ADD_SEQUENCES_LOADING, payload:true});
    try{
      const data = await axios.post(SEQUENCE_URL, payload, config);
      dispatch({type:ADD_SEQUENCES, payload:data});
      return await Promise.resolve(data.data);
    }
    catch(err){
      dispatch({type:ADD_SEQUENCES_FAIL});
      dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Discovery page - SEQUENCE API (POST) - '  + SEQUENCE_URL + " " + err}));
      console.error(err);
      history.push('/500');
    }

  }
}


/**
 * Set active builder city
 * @param {String} value - city
 */
export function SetBuilderCity(value){
  return dispatch => dispatch({type:SET_BUILDER_CITY, payload:value})
}


/**
 * add builder item
 * @param {Object} builderPayload - builder payload
 * @param {Object} reservationsPayload - reservations payload
 */
export function AddBuilderItem(builderPayload, reservationsPayload){
  return dispatch => {
    dispatch({type:ADD_BUILDER_ITEM, payload:builderPayload});
    if(reservationsPayload !== null) dispatch({type:ADD_RESERVATION_ITEM, payload:reservationsPayload})
  }
}

/**
 * remove builder item
 * @param {number} index - index of array to be removed
 * @param {string} city - last active city
 * @param {boolean} isProduct - is product type
 */
export function RemoveBuilderItem(index, city, isProduct, productNumber){
  return dispatch => {
    dispatch({type:REMOVE_BUILDER_ITEM, payload:index});
    dispatch({type:REMOVE_RESERVATION_ITEM, payload: isProduct ? index-productNumber : index });
    dispatch({type:SET_BUILDER_CITY, payload:city});
  }
}


/**
 * Clear builder list
 */
export function ClearBuilderList(){
  return dispatch => dispatch({type:CLEAR_BUILDER_LIST})
}



// WEBPACK FOOTER //
// ./src/actions/builder.js